module.exports = __webpack_public_path__ + "img/pw.45c78a36.svg";